export default __webpack_public_path__ + "static/Sportive-c5a2dcf6f6be417d52fcb2c881bd829f.jpg";